"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Context = react_1.default.createContext({});
exports.default = Context;



//////////////////
// WEBPACK FOOTER
// ./src/Context.ts
// module id = 6
// module chunks = 0